import MuiIconButton, { IconButtonProps } from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

export interface CustomIconButtonProps extends IconButtonProps {}

const CustomIconButton = styled(MuiIconButton)<CustomIconButtonProps>(
  ({ theme }) => ({
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.otherBackgroundLight.main,
    borderRadius: "8px",
    width: "32px",
    height: "32px",
    border: `1px solid ${theme.palette.otherDivider.main}`,
    "&:hover": {
      backgroundColor: theme.palette.otherBackground.main,
    },
  })
);

export default CustomIconButton;
